import { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router'

import { usePrototypeContext } from './usePrototypeContext'
import { COMMENT_SEGMENT } from '../../shares/constants'

export const usePrototypeComments = () => {
  const { isFullscreen } = usePrototypeContext()
  const history = useHistory()
  const location = useLocation()

  const commentsEnabled = location.hash.includes(COMMENT_SEGMENT)

  const setCommentsState = useCallback(
    (commentsEnabled: boolean) => {
      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: commentsEnabled ? COMMENT_SEGMENT : undefined,
      })
    },
    [history, location.pathname, location.search]
  )

  return [commentsEnabled && !isFullscreen, setCommentsState] as const
}
